import React from 'react';
import { steps } from '../data/landing';
export function HowItWorksSection() {
  return <section className="bg-ink" data-id="element-102" data-mp="fth93t8iquv2">
      <div className="mx-auto max-w-6xl px-5 py-10 md:px-6 md:py-16 lg:py-20" data-id="element-103" data-mp="fs66vxuq1v62">
        <div className="flex flex-col justify-between gap-1 md:flex-row md:items-end md:gap-4" data-id="element-104" data-mp="ui51jqn2iogs">
          <h2 className="font-display text-xl text-cream md:text-3xl lg:text-4xl" data-id="element-105" data-mp="piip3jf2dc91">
            ¿Cómo funciona la compra?
          </h2>
          <p className="font-serif text-base italic text-gold-light md:text-xl" data-id="element-106" data-mp="1tg90g02vrgn">
            Sin suscripciones. Sin cuotas mensuales.
          </p>
        </div>

        <ol className="mt-5 grid gap-4 md:mt-10 md:grid-cols-3 md:gap-8" data-id="element-107" data-mp="au4lv7dqjlry">
          {steps.map((s, i) => <li key={s.title} className="grid grid-cols-[2.25rem_1fr] gap-3 md:block" data-id="element-108" data-mp="6r7y729c8zh5" data-mpi={i}>
              <div className="flex items-center gap-4" data-id="element-109" data-mp="1m787dauls6vj">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-gold font-display text-sm text-gold md:h-11 md:w-11 md:text-base" data-id="element-110" data-mp="1i87qhxvoreb6">
                  {i + 1}
                </span>
                {i < steps.length - 1 && <span aria-hidden="true" className="hidden h-px flex-1 bg-line md:block" data-id="element-111" data-mp="15bb7udicxkxd" />}
              </div>
              <div data-id="element-112" data-mp="1aanwn3ssh22l">
                <h3 className="pt-1.5 font-display text-[15px] text-cream md:mt-5 md:pt-0 md:text-lg" data-id="element-113" data-mp="1a94gdd74ur0t">
                  {s.title}
                </h3>
                <p className="mt-0.5 max-w-xs text-sm leading-relaxed text-muted md:mt-2 md:text-base" data-id="element-114" data-mp="hlgxc2lig8ga">
                  {s.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}